import * as api from '@api';
import { transformFacilityProcesses } from '@utils';
import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@/hooks/useApi';

export default function useFacilityProcessesList() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const prefetchData = async () => {
      //Only prefetch if data is not already in the cache
      if (!queryClient.getQueryData('getFacilityProcesses')) {
        await queryClient.prefetchQuery(
          'getFacilityProcesses',
          api.backend.facilityProcessesDropdown,
        );
      }
    };
    prefetchData();
  }, [queryClient]);

  const { data: queryData, isSuccess } = useQuery(
    'getFacilityProcesses',
    api.backend.facilityProcessesDropdown,
    {
      gcTime: 24 * 3600 * 1000,
      staleTime: 24 * 3600 * 1000,
      initialData: () => {
        return queryClient.getQueryData('getFacilityProcesses');
      },
      // Only run the query if data is not already in the cache
      enabled: !queryClient.getQueryData('getFacilityProcesses'),
    },
  );

  const facilityProcessesList = isSuccess
    ? transformFacilityProcesses(queryData?.data?.data)
    : [];

  return facilityProcessesList;
}
